import React from 'react';
import useCsvMembers from '../hooks/useCsvMembers';
import CommitteeSection from '../components/committee/CommitteeSection';
import './CommitteePages.css';


const InternationalScientificCommitteePage = () => {
  const members = useCsvMembers('/data/international_scientific_committee.csv');
  return (
    <CommitteeSection heading="International Scientific Committee" members={members} />
  );
};

export default InternationalScientificCommitteePage;
